<!-- @format -->

<ng-container *transloco="let t">
  <sis-common-attainment-details [attainment]="attainment" [secondaryAttainments]="secondaryAttainments">
    @if (expirationImminent) {
      <ng-template #expirationNotification>
        <sis-attainment-expiration-notification [attainment]="attainment"></sis-attainment-expiration-notification>
      </ng-template>
    }
    <ng-template #thesisInformation>
      <sis-thesis-details [attainment]="attainment"></sis-thesis-details>
    </ng-template>
    @if (attainment?.creditTransferInfo) {
      <ng-template #creditTransferInformation>
        <sis-attainment-credit-transfer-info-details [creditTransferInfo]="attainment.creditTransferInfo">
        </sis-attainment-credit-transfer-info-details>
      </ng-template>
    }
    <ng-template #registrationDetails>
      <div class="form-group-mimic" role="listitem">
        <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.REGISTRATION_DATE") }}</dt>
        <dd>{{ attainment.registrationDate | localDateFormat }}</dd>
      </div>
    </ng-template>

    <ng-template #curriculumPeriods>
      <div sis-curriculum-periods-details class="form-group-mimic" role="listitem" [attainment]="attainment"></div>
    </ng-template>

    <ng-template #rdiCredits>
      @if (rdiCreditsEnabled === "ENABLED" && attainment.rdiCredits) {
        <div class="form-group-mimic" role="listitem">
          <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.RDI_CREDITS") }}</dt>
          <dd>
            {{ attainment.rdiCredits }}
          </dd>
        </div>
      }
      @if (rdiCreditsEnabled === "ENABLED" && !attainment.rdiCredits) {
        <div class="form-group-mimic" role="listitem">
          <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.RDI_CREDITS") }}</dt>
          <dd> - </dd>
        </div>
      }
      @if (rdiCreditsEnabled === "DISABLED" && attainment.rdiCredits) {
        <div class="form-group-mimic" role="listitem">
          <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.RDI_CREDITS") }}</dt>
          <dd>
            {{ attainment.rdiCredits }}
          </dd>
        </div>
      }
    </ng-template>
  </sis-common-attainment-details>
  @if (gradeRaiseAttemptEnabled && (gradeRaiseEnabled || gradeRaiseInfoEnabled)) {
    <div class="grade-raise-info">
      <fudis-heading [level]="3">{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_TITLE") }}</fudis-heading>
      @if (!isAttachedToPrimaryAttainment) {
        @if (!isCrossStudyCourseUnit) {
          @if (gradeRaiseEnabled) {
            @if (completionMethodsAvailable && !gradeRaiseAttempt) {
              <p class="sis-mt-sm sis-mb-sm">{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_HELP_TEXT") }}</p>
            }
            @if (gradeRaiseCourseUnitVersion$ | async; as data) {
              @if (completionMethodsAvailable && gradeRaiseAttempt) {
                <p class="sis-mt-sm sis-mb-sm">{{
                  t("ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_ONGOING_HELP_TEXT", {
                    completionMethodIndex: getCompletionMethodIndexForGradeRaise(data),
                  })
                }}</p>
              }
            }
            @if (!completionMethodsAvailable) {
              <div class="sis-mb-sm">
                <sis-contextual-notification variant="warning">{{
                  t("ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_WARNING_TEXT")
                }}</sis-contextual-notification>
              </div>
            }
            @if (completionMethodsAvailable) {
              <fudis-button
                [size]="'small'"
                [variant]="'tertiary'"
                [label]="t(gradeRaiseButtonTranslationKey())"
                (handleClick)="this.modalRef.close({ openSelectCompletionMethodModal: true })"></fudis-button>
            }
          }
          @if (gradeRaiseInfoEnabled) {
            <fudis-body-text [variant]="'lg-light'">
              {{ t("ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_GUIDANCE_1") }}
              <a
                fudisLink
                [title]="t('ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_GUIDANCE_LINK_TITLE')"
                [href]="planHref"
                (click)="modalRef.close()"></a>
              {{ t("ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_GUIDANCE_2") }}
            </fudis-body-text>
          }
        } @else {
          <fudis-body-text class="sis-mb-sm" variant="lg-light">{{
            t("ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_GUIDANCE_CROSS_STUDY_1")
          }}</fudis-body-text>
          <sis-contextual-notification variant="warning">
            {{ t("ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_GUIDANCE_CROSS_STUDY_2") }}
          </sis-contextual-notification>
        }
      }
      @if (isAttachedToPrimaryAttainment) {
        <p class="sis-mt-sm sis-mb-sm">{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_HELP_TEXT_BASE") }}</p>
        <sis-contextual-notification variant="warning">
          <span translate="ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_HAS_PARENT_ATTAINMENT"></span>
        </sis-contextual-notification>
      }
    </div>
  }
</ng-container>
